<template>
  <QsDrawer
    title="绑定账号"
    :visible.sync="visible"
    :wrapperClosable="true"
    :before-close="handleClose"
    cusSize="xl"
  >
    <div class="container">
      <div class="table-wrapper">
        <QS-common-table
          :columns="columns"
          :data="tableData"
          :loading="loading"
          :pagination="pagination"
          @change="pageChange"
       />
      </div>
    </div>
    <template #footer>
      <footer class="content-footer">
        <el-button @click="handleClose">取消</el-button>
      </footer>
    </template>
  </QsDrawer>
</template>

<script setup>
import { ref } from 'vue'
import { tableFakeHook } from './hooks'

const visible = ref(false)
const roleId = ref(null)
const detailDrawerRef = ref(null)
const loading = ref(false)

// 获取table 操作
const getOperateList = () => []

const beforeFetch = () => {
  if (!roleId.value) return false
  loading.value = true
  return {
    roleId: roleId.value,
  }
}

const {
  tableData,
  columns,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleSelectionChange,
  pagination,
  pageChange,
  getEmployeeList,
} = tableFakeHook(
  getOperateList,
  beforeFetch,
  () => {
    loading.value = false
  },
  (row) => {
    detailDrawerRef.value.open(row.id, 'detail')
  },
)

const handleClose = () => {
  visible.value = false
}
const openModal = (id) => {
  visible.value = true
  roleId.value = id
  getEmployeeList()
}
// 关闭弹窗
const closeModal = () => {
  visible.value = false
}

defineExpose({
  open: openModal,
  close: closeModal,
})
</script>
<style lang="scss" scoped>
.container {
  padding: 0 8px;
  background-color: #fff;
}
.table-wrapper{
  padding-bottom: 24px;
}
.content-footer {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 16px;
}


</style>
